import { Translate } from '@src/i18n/useTranslate';

import { z } from 'zod';
import { isValidVerificationCode } from '@src/domains/customers';

export const schema = (t: Translate['i18n']) => {
  const requiredMessage = t('direct_link_required_field');

  const requiredStringField = z.string({ required_error: requiredMessage }).nonempty({ message: requiredMessage });

  return z
    .object({
      otp: requiredStringField.refine(isValidVerificationCode, {
        message: t('auth_invalid_verification_code'),
      }),
    })
    .transform((data) => {
      return {
        otp: data.otp,
      };
    });
};
